"use client";

import { EmptyProjectsIllustration } from "@/components/illustrations/empty-projects-illustration";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { LearnMoreCard } from "@/components/ui/learn-more-card";

interface ProjectsEmptyWelcomeProps {
  onCreate: () => void;
  onLearnMore: () => void;
}

export function ProjectsEmptyWelcome({
  onCreate,
  onLearnMore,
}: ProjectsEmptyWelcomeProps) {
  return (
    <section
      aria-labelledby="projects-welcome-heading"
      className="bg-surface-primary flex flex-col items-center h-full"
    >
      <div className="flex-1 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <EmptyProjectsIllustration priority aria-hidden="true" />
          <div className="flex flex-col items-center gap-4">
            <div className="flex flex-col items-center gap-[7px] text-center leading-normal">
              <h2
                id="projects-welcome-heading"
                className="text-xl font-medium text-heading tracking-[-0.2px]"
              >
                Welcome to Projects
              </h2>
              <p className="text-sm font-normal text-contrast/60 tracking-[-0.14px]">
                Any available projects will show here.
              </p>
            </div>
            <Button onClick={onCreate} variant="light" size="sm">
              Create Project
              <Icon name="IconPlusLarge" />
            </Button>
          </div>
        </div>
      </div>

      <div className="pb-10">
        <LearnMoreCard
          description="Learn everything about projects and how to organize jobs in Arbi."
          onClick={onLearnMore}
        />
      </div>
    </section>
  );
}
